import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactItemPickerComponent, ContractorEmployeePickerComponent, ContractorAllocationEmployeePickerComponent } from './components';
import { NgSelectModule } from '@ng-select/ng-select';
import { AvatarModule } from '@jms/ui/ui.avatar';
import { PipeModule } from '@jms/utils/util.pipes';
import { FieldModule } from '@jms/ui/ui.field';
import { ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';

const components = [
  ContractorAllocationEmployeePickerComponent,
  ContractorEmployeePickerComponent
];

@NgModule({
  declarations: [
    ...components,
    ContactItemPickerComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    AvatarModule,
    PipeModule,
    FieldModule,
    TooltipModule,
    PipeModule
  ],
  exports: [...components]
})
export class PortalContactPickerModule { }
